<template>
  <component
    :is="isLink ? 'a' : 'button'"
    :href="href ? href : null"
    class="ui-button"
    :class="buttonClasses"
    :type="type"
    :aria-label="iconOnly ? label : null"
    :aria-labelledby="!iconOnly ? label : null"
    :target="href ? '_blank' : null"
    @click="onClick"
  >
    <span class="ui-button__icon backoffice-icons" v-if="icon && !svg">
      {{ icon }}
    </span>
    <img :src="require(`@/assets/img/svg/${svg}.svg`)" class="ui-button__svg" v-if="svg" />
    <span class="ui-button__label" v-if="!iconOnly">
      {{ label }}
    </span>
  </component>
</template>

<script>
export default {
  name: 'Button',
  props: {
    button: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
      default: '',
    },
    iconOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    variant: {
      type: String,
      required: false,
      default: '',
    },
    svg: {
      type: String,
      required: false,
      default: '',
    },
    type: {
      type: String,
      required: false,
      default: 'button',
    },
    isLink: {
      type: Boolean,
      required: false,
      default: false,
    },
    href: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    buttonClasses() {
      const classes = [`ui-button--${this.button}`]

      if (this.variant) {
        classes.push(`ui-button--${this.button}--${this.variant}`)
      }

      if (!this.iconOnly && (this.icon || this.svg)) {
        classes.push(`ui-button--text-icon`)
      } else if (this.iconOnly && (this.icon || this.svg)) {
        classes.push(`ui-button--icon`)
      }

      return classes
    },
  },
  methods: {
    onClick($event) {
      /**
       * Emitted when the button is clicked.
       * @event click
       * @type {Event}
       */
      this.$emit('click', $event)
    },
  },
}
</script>

<style lang="scss">
.ui-button {
  &--cta {
    @include button-cta;
  }

  &--primary {
    @include button-primary;
  }

  &--secondary {
    @include button-secondary;
  }

  &--icon {
    @include button-icon;
  }

  &--text-icon {
    @include button-text-icon;
  }
}
</style>
